import { render, staticRenderFns } from "./ningxiaUnionPayUnionConfigure.vue?vue&type=template&id=42d79d91&scoped=true&"
import script from "./ningxiaUnionPayUnionConfigure.vue?vue&type=script&lang=js&"
export * from "./ningxiaUnionPayUnionConfigure.vue?vue&type=script&lang=js&"
import style0 from "./ningxiaUnionPayUnionConfigure.vue?vue&type=style&index=0&id=42d79d91&scoped=true&lang=css&"
import style1 from "./ningxiaUnionPayUnionConfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d79d91",
  null
  
)

export default component.exports